import React from 'react';
import { Mutation } from '@apollo/client/react/components';

import RestoreIdeaSearchAlert from 'buyside/graphql/mutations/RestoreUserIdeaSearchAlert';

import DeletedSavedIdeaSearches from 'buyside/components/presentation/UserAccount/SavedSearches/deletedSavedIdeaSearches';

const DeletedSavedIdeaSearchesContainer = ({ deletedSearches, removeFromSoftDelete }) => (
  <Mutation mutation={RestoreIdeaSearchAlert}>
    {mutate => {
      const restoreIdeaSearchAlert = args => mutate({ variables: args });
      return (
        <DeletedSavedIdeaSearches
          deletedSearches={deletedSearches}
          handleRestoreSearchAlert={({ id, name, active, display, ideaSavedSearch }) => {
            delete deletedSearches[`${id}`];
            removeFromSoftDelete(deletedSearches);
            restoreIdeaSearchAlert({
              name,
              active,
              display,
              ideaSavedSearchId: ideaSavedSearch.id
            });
          }}
          removeFromSoftDelete={removeFromSoftDelete}
        />
      );
    }}
  </Mutation>
);

export default DeletedSavedIdeaSearchesContainer;
